import loaderImg from '@assets/loader_200_trasp.gif'

const LoaderMaxi = () => {
    return (
        <div className='mt-1 flex items-center gap-2'>
            <img src={loaderImg} alt='loader' className='md:w-[150px] md:h-[150px] w-[100px] h-[]100px animate-spin' />
           
        </div>
    )
}

export default LoaderMaxi
